export const StampType = <const>{
  FootMeasurement: 'foot_measurement',
  ExtraBonus: 'extra_bonus',
  CreateArtwork: 'create_artwork',
  Birthday: 'birthday',
  PublishedGallery: 'published_gallery',
  RegisterShoes: 'register_shoes',
};

export type StampType = (typeof StampType)[keyof typeof StampType];
